module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Ball Park")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head1"
  }, [_c('em', [_vm._v("Recent titles by John Farrow")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1-space-after"
  }, [_c('em', [_vm._v("Émile Cinq-Mars thrillers")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1"
  }, [_vm._v("CITY OF ICE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1"
  }, [_vm._v("ICE LAKE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1"
  }, [_vm._v("RIVER CITY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1"
  }, [_vm._v("THE STORM MURDERS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1"
  }, [_vm._v("SEVEN DAYS DEAD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1"
  }, [_vm._v("PERISH THE DAY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1-space-after"
  }, [_vm._v("BALL PARK *")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text1"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('em', [_vm._v("* available from Severn House")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11794cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 60
// module chunks = 0